import styled from 'styled-components';
import { Card } from 'core/components';

const InfoCard = styled(Card)`
  flex: ${(props) => props.flex || '1 1 auto'};
  font-size: 14px;
  display: grid;
  align-content: flex-start;
  grid-template-columns: auto 1fr;
  column-gap: 16px;
  row-gap: 4px;
  min-width: 180px;
  overflow: hidden;
  padding: 12px;

  .label {
    color: ${(props) => props.theme.colors.muted};
    white-space: nowrap;
  }

  .value {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export { InfoCard };
